import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import WorkExperience from 'src/constants/workExperience';

export interface CompetitorAnalysisParams {
    positionName?: string;
    professionalRole?: string[];
    compensationFrom: number | null;
    compensationTo: number | null;
    compensationGross: boolean | null;
    workExperience?: WorkExperience;
    area?: string;
}

interface CompetitorAnalysis extends CompetitorAnalysisParams {
    suggestUrl: string;
    reportUrl: string;
    initialParams: {
        positionName: string;
        professionalRole: string[];
        compensationFrom: number;
        compensationTo: number;
        compensationGross: boolean;
        workExperience: WorkExperience;
        area: string;
    };
}

export default autoGeneratedReducer<Partial<CompetitorAnalysis>>({});
